import WorkerDashboard from './WorkerDashboard';

export default WorkerDashboard;
